import { isLegalMove } from './engine';
import type { Difficulty, GameState, SearchResult } from './types';

export type EngineBackend = 'v1' | 'pikafish';

const PIKAFISH_LEVELS = new Set<Difficulty>([
  'attacker', 'defender', 'pawn', 'miser', 'blockader', 'scholar', 'veteran', 'master',
]);

export function preferredBackend(difficulty: Difficulty): EngineBackend {
  return PIKAFISH_LEVELS.has(difficulty) ? 'pikafish' : 'v1';
}

export function supportsPikafishRuntime(): boolean {
  return typeof WebAssembly !== 'undefined'
    && typeof SharedArrayBuffer !== 'undefined'
    && globalThis.crossOriginIsolated === true;
}

export function createSearchWorker(backend: EngineBackend): Worker {
  return backend === 'pikafish'
    ? new Worker('/engine/pikafish.js', { name: 'cloud-xiangqi-pikafish' })
    : new Worker(new URL('./ai.worker.ts', import.meta.url), { type: 'module', name: 'cloud-xiangqi-v1' });
}

export function shouldSoftCancelPikafish(backend: EngineBackend | null, ready: boolean, forceTerminate: boolean): boolean {
  return backend === 'pikafish' && ready && !forceTerminate;
}

export function isUsableResult(state: GameState, result: SearchResult): boolean {
  if (!result.move) return state.outcome !== 'ongoing';
  return isLegalMove(state.board, state.sideToMove, result.move);
}

export function engineLabel(engine: SearchResult['engine']): string {
  if (engine === 'book') return '角色棋譜';
  if (engine === 'pikafish') return 'Pikafish';
  if (engine === 'v1-pro') return 'V1-Pro';
  if (engine === 'v1-fallback') return 'V1 接手';
  return 'V1';
}
